import React from 'react'
import './productcategories.scss'
import BreadCrumb from 'Components/Common/BreadCrumb'
import { useParams } from 'react-router-dom'
import { Container } from 'reactstrap'
const Productcategories = () => {
    const { id, } = useParams();
    return (
        <div className='page-content'>
            <Container fluid>
                <BreadCrumb title={id ? "Edit Product" : "Add Product"} pageTitle="Products" pageTitleRoute="/manage-products" />
                <div className="mb-3">
                    <h5 className='head'>All</h5>
                    <div className="bg-white">
                        <div className="section-title">Recent Used</div>
                        <hr />
                        <div className="box">
                            <div className="box-text">
                                TV, Audio / Video, Gaming & Wearable <i className='bx bx-chevron-right arrow'></i>
                                Audio <i className='bx bx-chevron-right arrow'></i>
                                Audio Accessories <i className='bx bx-chevron-right arrow'></i>
                                Screen Guard's
                            </div>
                            <hr />
                            <div className="box-text-2">
                                Kids and Baby Fashion <i className='bx bx-chevron-right arrow'></i>
                                Baby Boy Fashion <i className='bx bx-chevron-right arrow'></i>
                                Baby Boy Bottom <i className='bx bx-chevron-right arrow'></i>
                                Baby Boy Short
                            </div>

                        </div>
                    </div>
                    <div className="bg-white">
                        <div className="section-title">Choose for Yourself</div>
                        <hr />

                        <div className="link-box">Kids & Baby Fashion <span className="arrow">›</span></div>
                        <div className="link-box">Mobile & Tablets <span className="arrow">›</span></div>
                        <div className="link-box">Computer & Laptops <span className="arrow">›</span></div>
                        <div className="link-box">TV, Audio / Video, Gaming & Wearable <span className="arrow">›</span></div>
                        <div className="link-box">Cameras <span className="arrow">›</span></div>
                        <div className="link-box">Home Appliances <span className="arrow">›</span></div>
                        <div className="link-box">Health & Beauty <span className="arrow">›</span></div>
                        <div className="link-box">Fashion <span className="arrow">›</span></div>
                        <div className="link-box">Furniture <span className="arrow">›</span></div>
                    </div>
                </div>


            </Container>
        </div>
    )
}
export default Productcategories
